import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Lock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';

const API_BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

const TechLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const { data } = await axios.post(`${API_BASE}/api/tech/login`, {
        username: username.trim(),
        password,
      });
      if (data.status === 'success') {
        localStorage.removeItem('isAuthenticated');
        localStorage.setItem('authToken', data.token || '');
        localStorage.setItem('techAuthenticated', 'true');
        localStorage.setItem('userRole', 'tech');
        localStorage.setItem('technicianName', data.full_name || '');
        localStorage.setItem('techUser', JSON.stringify({
          name: data.full_name || username,
          email: data.email,
          role: 'tech',
        }));
        navigate('/tech/dashboard');
      } else {
        setError('Invalid username or password.');
      }
    } catch (err) {
      const msg = err.response?.data?.detail;
      setError(msg === 'Invalid credentials' ? 'Invalid username or password.' : (msg || 'Could not connect. Try again.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-900 via-green-800 to-green-700">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-green-700 rounded-full flex items-center justify-center mx-auto mb-4">
              <User className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Tech Portal</h1>
            <p className="text-gray-500 text-sm mt-1">AAA Irrigation Service</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Username or Email</label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                <Input
                  type="text"
                  placeholder="Your ERPNext username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="pl-10 h-12"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                <Input
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pl-10 h-12"
                  required
                />
              </div>
            </div>

            {error && (
              <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-center">
                {error}
              </p>
            )}

            <Button
              type="submit"
              className="w-full h-12 bg-green-700 hover:bg-green-800 text-white font-semibold"
              disabled={isLoading}
            >
              {isLoading ? 'Signing in…' : 'Sign In'}
            </Button>
          </form>

          <p className="text-center text-xs text-gray-400 mt-6">
            Powered by Boatman Systems™
          </p>
        </div>
      </div>
    </div>
  );
};

export default TechLogin;